export let CommonState = /*#__PURE__*/function (CommonState) {
  CommonState[CommonState["DISABLED"] = 0] = "DISABLED";
  CommonState[CommonState["ENABLED"] = 1] = "ENABLED";
  return CommonState;
}({});
//# sourceMappingURL=common.enum.js.map